/**
 * State
 * @type {Object}
 */
const state = {
    data: null,
    change: new Date(),
    messages: [],
    chatter: ''
}

/**
 * Getters
 * @type {Object}
 */
const getters = {
    isLoaded: (state) => (id) => {
        return ( state.data && state.data.id == id );
    },
    id: (state) => state.data ? state.data.id : null,
    kenmerk: (state) => state.data ? state.data.kenmerk : ''
}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    load({commit, getters}, id) {

        return new Promise( (resolve, reject) => {

            if ( getters.isLoaded(id) ) {
                resolve();
            }
            else {
                this.$xhr.get('/api/invoices/' + id + '/').then( ({result}) => {
                    commit('add', result);
                    resolve();
                }).catch(reject)
            }
        });
    },

    reload({commit, getters}) {

        return new Promise( (resolve, reject) => {

            if ( getters.id ) {
                this.$xhr.get('/api/invoices/' + getters.id + '/').then( ({result}) => {
                    commit('add', result);
                    resolve();
                }).catch(reject)
            }
        });
    },

    approved({commit, dispatch}, change) {
        dispatch('reload').then( () => {}).catch((e) =>{ console.alert(e) });
        //commit('changeAssignment', change);
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

    add(state, data ) {
        state.data = data;
    },

    approved(state) {
        state.data.approved = true;
    },

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
